import React, { memo } from 'react';
import { TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { UserAvatar, Space, Text } from '@redlink/components/atoms';

export const UserBadgeContainer = memo(({ avatarUrl, fullname, onPress }) => {
  const { styles } = useStyle();
  return (
    <TouchableOpacity
      {...{ onPress }}
      activeOpacity={0.7}
      style={styles.userContainer}
    >
      <UserAvatar style={styles.userAvatarImage} source={{ uri: avatarUrl }} />
      <Space size={8} />
      <Text style={styles.userTitleText}>{fullname}</Text>
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  userContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  userAvatarImage: {
    width: 24,
    height: 24,
  },
  userTitleText: {
    color: colors.subtitle,
    fontSize: 14,
  },
}));
